import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import { SalesOrderHeaderDetailsDialogComponent } from '../../sales-orders/sales-order-header-details-dialog/sales-order-header-details-dialog.component';

@Component({
  selector: 'app-pos-cash-up-report-dialog',
  templateUrl: './pos-cash-up-report-dialog.component.html',
  styleUrls: ['./pos-cash-up-report-dialog.component.scss']
})
export class PosCashUpReportDialogComponent implements OnInit {
  form: FormGroup;
  stores: any[];
  reportConfig: any;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderHeaderDetailsDialogComponent>,
    private fb: FormBuilder,
    private baseService: BaseService,
    private notificationService: NotificationService,
  ) {
    const today = new Date();
    this.form = fb.group({
      storeId: [null, Validators.compose([Validators.required])],
      eodDate: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.baseService.executeCommand<any>('portal_money_container_batch_eod_supervisor_report_dialog_config', { "test": 1 })
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.stores = response.data.stores;
          this.reportConfig = response.data.reportConfig;

          if (this.stores && this.stores.length === 1) {
            this.form.controls['storeId'].setValue(this.stores[0].storeId)
          }
        } else {
          this.dialogRef.close();
        }
      });
  }

  save() {
    this.baseService.generateReport({ reportConfig: this.reportConfig, reportParameters: this.form.value });
    setTimeout(() => {
      this.dialogRef.close();
    }, 200);
  }

}
